var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.visible ? _c('div', {
    staticClass: "fixed inset-0 z-50 flex items-center justify-center"
  }, [_c('div', {
    staticClass: "fixed inset-0 bg-black bg-opacity-50",
    on: {
      "click": _vm.onCancel
    }
  }), _c('div', {
    staticClass: "relative w-full max-w-md mx-4 bg-white rounded-lg shadow-lg"
  }, [_c('button', {
    staticClass: "absolute text-gray-400 top-4 right-4 hover:text-gray-600 focus:outline-none",
    on: {
      "click": _vm.onCancel
    }
  }, [_c('svg', {
    staticClass: "w-6 h-6",
    attrs: {
      "fill": "none",
      "stroke": "currentColor",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      "d": "M6 18L18 6M6 6l12 12"
    }
  })])]), _c('div', {
    staticClass: "p-6 text-center"
  }, [_c('h3', {
    staticClass: "mb-4 text-lg font-semibold text-gray-900"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")]), _vm.hasAdminWarning ? _c('p', {
    staticClass: "mb-6 leading-relaxed text-gray-600"
  }, [_vm._v(" You've assigned " + _vm._s(_vm.adminCountLabel) + " to "), _c('b', [_vm._v(_vm._s(_vm.vendorName))]), _vm._v(" before. Please recheck before continuing. ")]) : _c('p', {
    staticClass: "mb-6 leading-relaxed text-gray-600"
  }, [_vm._v(" " + _vm._s(_vm.message || '') + " ")]), _c('div', {
    staticClass: "flex justify-center space-x-3"
  }, [_c('Button', {
    staticClass: "px-6 py-2",
    attrs: {
      "color": "primary",
      "size": "base"
    },
    on: {
      "click": _vm.onContinue
    }
  }, [_vm._v(" " + _vm._s(_vm.continueText) + " ")]), _c('Button', {
    staticClass: "px-6 py-2",
    attrs: {
      "color": "alternative",
      "variant": "outlined",
      "size": "base"
    },
    on: {
      "click": _vm.onCancel
    }
  }, [_vm._v(" " + _vm._s(_vm.cancelText) + " ")])], 1)])])]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }